import { __decorate } from "tslib";
import * as CONST from '../const';
import Reportable from '../decorators/reportable';
import UIOverlay from './overlay';
import UIPreviewCloseupRenderer from './closeup.renderer';
class UIPreviewCloseup {
    owner;
    CONTAINER_TYPE = 'closeup';
    CLOSEUP_CONTAINER = 'calc_closeup';
    overlay;
    renderer;
    constructor(owner, project) {
        this.owner = owner;
        this.renderer = new UIPreviewCloseupRenderer(owner, project, this.CONTAINER_TYPE, this.CLOSEUP_CONTAINER);
    }
    render() {
        this.renderOverlay();
        this.renderer.render();
    }
    renderOverlay() {
        if (typeof this.overlay === 'undefined') {
            this.overlay = new UIOverlay({
                data: {
                    'calculatorId': this.owner.getUniqueId()
                },
                containerId: `calculator-container-${this.CONTAINER_TYPE}`,
                contentId: this.CLOSEUP_CONTAINER,
                layer: CONST.CLOSEUP_LAYER
            });
        }
        this.overlay.render(100, ['scroll-less', 'wide']);
    }
}
__decorate([
    Reportable
], UIPreviewCloseup.prototype, "render", null);
__decorate([
    Reportable
], UIPreviewCloseup.prototype, "renderOverlay", null);
export default UIPreviewCloseup;
